var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Box" },
    [
      _c(
        "el-card",
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "一级分拣（Triagem Nível 1）",
                    name: "first",
                  },
                },
                [
                  _c("levelOne", {
                    ref: "levelOne",
                    on: { parentMethod: _vm.openMiss },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "二三级分拣（Triagem Níveis 2-3）",
                    name: "second",
                  },
                },
                [
                  _c("levelTwoThree", {
                    ref: "levelTwoThree",
                    on: { parentMethod: _vm.openMiss },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "漏扫明细（Detalhes Perdidos）",
            visible: _vm.missVisible,
            width: "80%",
            "before-close": _vm.missClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.missVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.missExportAll },
                },
                [_vm._v("导出（Exportar）")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.missTableData,
                size: "small",
                "max-height": "600",
                border: "",
                "header-cell-style": {
                  background: "#f2f2f1",
                  color: "#000",
                  "font-size": "15px",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号（No.）", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.missForm.pageNumber - 1) *
                                _vm.missForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "waybillNumber",
                  label: "运单号（Número de waybill）",
                  align: "center",
                  width: "170",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "waybillStatusName",
                  label: "运单状态（Status do Pacote）",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "missOperationTypeName",
                  label: "漏扫操作（Ops Perd.Digitalização）",
                  align: "center",
                  width: "170",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "missSite",
                  label: "漏扫网点（Centro de Digitalização Omitida）",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "state",
                  label: "网点所属州（Estado de origem）",
                  align: "center",
                  width: "170",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "regionName",
                  label: "所属大区（Pertence à região）",
                  align: "center",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.missForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100, 500, 1000],
                  "page-size": _vm.missForm.pageSize,
                  total: _vm.missTotal,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.missForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.missForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.missForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.missForm, "pageSize", $event)
                  },
                  "current-change": _vm.missPage,
                  "size-change": _vm.missSearch,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }